<div class="search-container">
    <mat-form-field class="search-filter">
        <input
            matInput
            placeholder="Search item tag or paste tagpath"
            [(ngModel)]="searchFilter"
            (paste)="handlePaste($event)"
        />
        <button mat-icon-button class="clear-search-button float-end" (click)="handleClearSearchButtonClicked()"
        matTooltip="Clear Search Term & Exit Search Mode">
            <i class="material-icons">close</i>
        </button>
    </mat-form-field>
    <button mat-icon-button class="search-button float-end" (click)="handleSearchButtonClicked()"
    matTooltip="Search for item tag or paste tagpath">
        <i class="material-icons">search</i>
    </button>
</div>
